import { serviceRoles } from "config/access";
import { SURVEYS } from "constants/routes";
import { checkAccess } from "helpers/auth";
import SurveyPage from "./container/SurveyPage";

export default function getSettingsRoute(userAuth) {
  const { account, harmony } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [harmony.name]: [harmony.roles.admin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: SURVEYS,
    withSidebar: true,
    withAppBar: true,
    component: SurveyPage,
  };
}
